export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = BYTES_IN_KB * BYTES_IN_KB;
